export default __webpack_public_path__ + "static/media/gil.5642fc89.png";